<ras-page [show_heading]="false" [thin_footer]="true" [menu]="false">

	<section class="header">
		<div>
			<h1>Get absolute peace of mind</h1>
			<p>with an A-grade high security storage unit at one of our 5-star facilities near you!</p>
		</div>
	</section>

	<section class="deal">
		<h2>This unmissable deal includes:</h2>
		<ul>
			<li><img src="/assets/iconPromotions.svg" alt="" />Your first month ABSOLUTELY FREE</li>
			<li><img src="/assets/iconTransport.svg" alt="" />Free move-in transport</li>
			<li><img src="/assets/iconSecurity.svg" alt="" />State of the art security</li>
			<li><img src="/assets/iconDeposit.svg" alt="" />No deposit or move-in fees</li>
			<li><img src="/assets/iconRentals.svg" alt="" />Month-to-month leases</li>
			<li><img src="/assets/iconOnline.svg" alt="" />Easy online booking</li>
			<li><img src="/assets/iconServiceExcellence.svg" alt="" />No hidden costs</li>
			<li><img src="/assets/iconSizes.svg" alt="" />1m² to 54m² units available</li>
			<!-- <li><img src="/assets/iconBoxPack.svg" />10 free boxes with every online rental</li> -->
		</ul>
	</section>

	<section class="book">
		<p>
			<span>Easily book your unit online right now within 15 minutes! Reserve online with no obligation or reservation fees.</span>
			<button (click)="show_popup = true">Book my unit now!</button>
		</p>
	</section>

	<section class="talk">
		<p>
			<img src="/assets/iconContact.svg" alt="" />
			If you are unsure and want to discuss your requirements, <a [routerLink]="['/contact']">click here</a> to talk to someone.
		</p>
	</section>

	<section>
		<h2>We know that there are 4 things you want from a storage unit: SECURITY, AFFORDABILITY, CONVENIENCE and CLEANLINESS.</h2>

		<p>
			<img align="left" src="/assets/iconSecurity.svg" />
			<span>We’ve invested heavily in IP cameras, remote monitoring and security guards to provide our customers with ABSOLUTE PEACE OF MIND that their goods are in safe hands.</span>
		</p>

		<p>
			<img align="left" src="/assets/iconPromotions.svg" />
			<span>Our transparent month-to-month prices are among the best in the business, and there are no hidden fees, plus the FIRST MONTH IS ON US!</span>
		</p>

		<p>
			<img align="left" src="/assets/iconOnline.svg" />
			<span>For your convenience we have facilities in MIDRAND, SANDTON, HONEYDEW, PRETORIA, CENTURION and soon in the EAST RAND. Easy online booking ensures a quick and painless experience, along with free move-in transport.</span>
		</p>

		<p>
			<img align="left" src="/assets/iconServiceExcellence.svg" />
			<span>Our 5-Star facilities offer neat, clean and tidy A-Grade units and employ clear headed and enthusiastic staff to ensure a friendly hassle-free experience – every time.</span>
		</p>

		<hr />

		<h3>We know moving is stressful and that you need your possessions to be safe and sound and conveniently accessible. We’ve made the whole process easy and friendly and look forward to welcoming you to one of our facilities.</h3>
	</section>

	<section class="book">
		<p>
			<span>Easily book your unit online right now within 15 minutes! Reserve online with no obligation or reservation fees.</span>
			<button (click)="show_popup = true">Book my unit now!</button>
		</p>
	</section>

	<section class="talk">
		<p>
			<img src="/assets/iconContact.svg" alt="" />
			If you are unsure and want to discuss your requirements, <a [routerLink]="['/contact']">click here</a> to talk to someone.
		</p>
	</section>

	<div class="popup" *ngIf="show_popup">
		<ras-popup variation="white" (close)="show_popup = false">
			<h1>Choose a location, find your unit and get a quick quote with an OTP</h1>

			<p>Reserve online with no obligation or reservation fees</p>
			<div class="choose-location">
				<div *ngFor="let item of locations | keyvalue">
					<ras-location-thumb [location]="item.value"></ras-location-thumb>
				</div>
			</div>
		</ras-popup>
	</div>
</ras-page>
